import { render, staticRenderFns } from "./RoleTree.vue?vue&type=template&id=1b59e4d5&scoped=true&"
import script from "./RoleTree.vue?vue&type=script&lang=js&"
export * from "./RoleTree.vue?vue&type=script&lang=js&"
import style0 from "./RoleTree.vue?vue&type=style&index=0&id=1b59e4d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b59e4d5",
  null
  
)

export default component.exports